import React from 'react'
import './Counter.css';
import CountUp from 'react-countup'
const Counter=()=> {
  
  return (
    <div className='Info'>
        <div className='Info__box'>
         <div>
           <h2 className='number'><CountUp end={200} />+</h2>
           <p className='case'>Jami o'qituvchilar</p>
         </div>
        </div>
        <div className='Info__box'>
         <div>
           <h2 className='number'><CountUp end={70}/>+</h2>
           <p className='case'>Fan doktorlaari</p>
         </div>
        </div>
        <div className='Info__box'>
         <div>
           <h2 className='number'><CountUp end={30}/>+</h2>
           <p className='case'>Fan nomzodi,PHD</p>
         </div>
        </div>
        <div className='Info__box'>
         <div>
           <h2 className='number'><CountUp end={75}/>+</h2>
           <p className='case'>Ilmiy darajasiz o'qituvchilar</p>
         </div>
        </div>
      </div>
  )
}

export default Counter